import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import API from "../api";

export default function LeadDetails() {
  const { id } = useParams();
  const [lead, setLead] = useState(null);
  const [tab, setTab] = useState("overview");
  const [message, setMessage] = useState("");

  useEffect(() => {
    API.get(`/leads/${id}`).then(res => setLead(res.data));
  }, []);

  const sendMessage = async () => {
    await API.post(`/leads/${id}/message`, { text: message });
    setMessage("");
    const res = await API.get(`/leads/${id}`);
    setLead(res.data);
  };

  if (!lead) return <div>Loading...</div>;

  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 bg-gray-50 min-h-screen">
        <Navbar />

        <div className="p-6 space-y-6">

          {/* HEADER */}
          <div className="bg-white p-6 rounded-xl shadow">
            <h1 className="text-2xl font-bold">{lead.title}</h1>
            <p className="text-gray-500">
              {lead.sector} · {lead.stage} · CO₂: {lead.co2Reduction}
            </p>
          </div>

          {/* DATA CARDS */}
          <div className="grid grid-cols-2 gap-4">

            <Card title="Contact">
              <p>{lead.contactInfo?.name}</p>
              <p>{lead.contactInfo?.email}</p>
              <p>{lead.contactInfo?.phone}</p>
            </Card>

            <Card title="Company">
              <p>{lead.companyInfo?.interest}</p>
              <p>{lead.companyInfo?.companyAge}</p>
              <p>{lead.companyInfo?.revenue}</p>
              <p>{lead.companyInfo?.ebitda}</p>
            </Card>

            <Card title="Project">
              <p>{lead.projectInfo?.reason}</p>
              <p>{lead.projectInfo?.biggestProjectSize}</p>
              <p>{lead.projectInfo?.fundingSource}</p>
            </Card>

            <Card title="Comments">
              <p>{lead.comments}</p>
            </Card>

          </div>

          {/* TABS */}
          <div className="flex gap-6 border-b pb-2">
            {["members","activity","chat"].map(t => (
              <button key={t}
                onClick={() => setTab(t)}
                className={tab === t ? "text-green-600 font-semibold" : ""}
              >
                {t}
              </button>
            ))}
          </div>

          {/* MEMBERS */}
          {tab === "members" && lead.members?.map((m,i)=>(
            <div key={i} className="bg-white p-4 rounded shadow">
              {m.name} — {m.role}
            </div>
          ))}

          {/* ACTIVITY */}
          {tab === "activity" && lead.activities?.map((a,i)=>(
            <div key={i}>{a.text}</div>
          ))}

          {/* CHAT */}
          {tab === "chat" && (
            <div className="bg-white p-4 rounded shadow">
              <div className="h-40 overflow-y-auto mb-2">
                {lead.messages?.map((m,i)=>(
                  <p key={i}><b>User:</b> {m.text}</p>
                ))}
              </div>

              <input
                className="w-full border p-2"
                value={message}
                onChange={e=>setMessage(e.target.value)}
              />

              <button onClick={sendMessage}
                className="mt-2 bg-green-500 text-white px-4 py-2 rounded">
                Send
              </button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

function Card({ title, children }) {
  return (
    <div className="bg-white p-4 rounded-xl shadow">
      <h3 className="font-semibold mb-2">{title}</h3>
      {children}
    </div>
  );
}